import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { NgbModal, NgbPopover } from '@ng-bootstrap/ng-bootstrap';

import { RenameBrigadeModalComponent } from '../../modals/rename-brigade-modal/rename-brigade-modal.component';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-brigade-actions-popover',
  templateUrl: './brigade-actions-popover.component.html',
  styleUrls: ['./brigade-actions-popover.component.scss'],
  standalone: false,
})
export class BrigadeActionsPopoverComponent implements OnInit {
  @Input() brigade;

  constructor(public modalService: NgbModal) {}

  ngOnInit() {}

  public toggleWithBrigadeActionsContext(popover: NgbPopover) {
    if (popover.isOpen()) {
      popover.close();
    } else {
      popover.open();
    }
  }

  public onOpenRenameBrigadeDialog() {
    let brigadeRenameDialog = this.modalService.open(RenameBrigadeModalComponent, {
      ariaLabelledBy: 'modal-basic-title',
      windowClass: 'modal-wrapper',
      backdrop: 'static',
    });

    brigadeRenameDialog.componentInstance.id = this.brigade.id;
    brigadeRenameDialog.componentInstance.brigadeName = this.brigade.brigade_name;
    brigadeRenameDialog.componentInstance.brigade = this.brigade;
  }
}
